import { styled } from 'libs/ui/styled';

import { DialogContent } from '../DialogContent';

export const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  [theme.breakpoints.down('mobile')]: {
    padding: '40px 16px',
  },
}));
